module.exports = __webpack_public_path__ + "static/media/fake-customer.3be4a592.png";